// Copy of daex-backend/src/serviceModules/objectives/objectives.progress.ts.
// Progress is calculated, never stored; change both files together.

type KeyResultForProgress = {
  type: "NUMBER" | "MILESTONE";
  startValue: number | null;
  targetValue: number | null;
  currentValue: number | null;
  done: boolean;
};

/** 0-100, or null if a NUMBER key result has no start or target yet. */
export const keyResultProgress = (
  keyResult: KeyResultForProgress,
): number | null => {
  if (keyResult.type === "MILESTONE") return keyResult.done ? 100 : 0;

  const { startValue, targetValue } = keyResult;
  if (startValue === null || targetValue === null) return null;
  if (startValue === targetValue) return keyResult.done ? 100 : 0;

  // Works for falling targets too (start 10 -> target 5)
  const current = keyResult.currentValue ?? startValue;
  const ratio = (current - startValue) / (targetValue - startValue);
  return Math.round(Math.min(Math.max(ratio, 0), 1) * 100);
};

/** Average of the key results, null if none has a progress. */
export const objectiveProgress = (
  keyResults: KeyResultForProgress[],
): number | null => {
  const values = keyResults
    .map(keyResultProgress)
    .filter((progress): progress is number => progress !== null);
  if (values.length === 0) return null;
  return Math.round(
    values.reduce((sum, value) => sum + value, 0) / values.length,
  );
};
